import { render, staticRenderFns } from "./Consumable.vue?vue&type=template&id=837ea41e&scoped=true&"
import script from "./Consumable.vue?vue&type=script&lang=js&"
export * from "./Consumable.vue?vue&type=script&lang=js&"
import style0 from "./Consumable.vue?vue&type=style&index=0&id=837ea41e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837ea41e",
  null
  
)

export default component.exports